export const PROVIDER_TIMEOUT_MS = 50000; // 50 seconds

export function withTimeout(promise, ms, providerName) {
  return new Promise((resolve, reject) => {
    const timer = setTimeout(() => {
      reject(
        normalizeSearchError(
          new Error(`Request timed out after ${ms}ms`),
          providerName,
          true
        )
      );
    }, ms);

    promise
      .then((value) => {
        clearTimeout(timer);
        resolve(value);
      })
      .catch((err) => {
        clearTimeout(timer);
        reject(normalizeSearchError(err, providerName, false));
      });
  });
}

/**
 * Normalizes errors into a consistent shape for UI and telemetry.
 */
export function normalizeSearchError(err, provider, timeout = false) {
  const code =
    err?.response?.status || (err?.code === "ECONNABORTED" ? 408 : "UNKNOWN");
  return {
    code,
    provider,
    timeout,
    message: err?.message || err?.response?.data?.message || "Unknown error",
    original: err,
  };
}

export function createAbortSignal() {
  return new AbortController();
}
